export default __webpack_public_path__ + "static/media/ser1.653c4cbc.jpg";